"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.borrowerChargesSchema = void 0;
var constants_1 = require("@hobt/constants");
var utils_1 = require("@hobt/utils");
var constants_2 = require("../../constants");
var futureDate = utils_1.getFutureDate(utils_1.getCurrentDate());
exports.borrowerChargesSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    properties: {
        code: {
            type: 'string',
            enum: __spreadArrays(Object.values(constants_2.BorrowerChargesCode), ['']),
            errorMessage: 'should be a valid BorrowerChargesCode Enum value',
        },
        comment: {
            type: 'string',
            minLength: 0,
            maxLength: 40,
            errorMessage: 'should have maximum length of 40 characters',
        },
        indexNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 300,
            errorMessage: 'Should be an integer between 0 and 300',
        },
        receivedAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        receivedDate: {
            type: 'string',
            format: 'date',
            formatMaximum: {
                const: futureDate,
                customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE, 'receivedDate'),
            },
            errorMessage: 'should be formatted as YYYY-MM-DD',
        },
    },
};
